<template>
    <paper>
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @btnClick="btnClick"
            @row-db-click="rowDBClick"
            searchId="singleList"
            pageID="singleList"
        >
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="REPORT_OTP_SINGLE_LIST_CONFIG"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="''">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>
    </paper>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import { getSearchList } from '../../../api/singleList';
import dayjs from 'dayjs';
import { mapState } from 'vuex';

export default {
    name: 'singleList',
    components: { mPane, paper, reportExport },
    data () {
        return {
            config: config,
            totalData: [],
            loading: false,
            editDialogVisible: false,
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                orderBy: 'createTime',
                orderByType: 'desc'
            },
            rowData: {},
            isFirstSearch: true,
            LINE_STATUS: {
                0: '未开始',
                10: '进行中',
                20: '排单成功',
                30: '排单失败'
            }
        };
    },
    methods: {
        handleClose (val) {
            if (val) {
                this.getList();
            }
            this.editDialogVisible = false;
        },
        getList () {
            this.loading = true;
            getSearchList(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list;
                    this.totalData.forEach(item => {
                        item.lineStatusName = this.LINE_STATUS[+item.lineStatus] || '';
                    });
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        btnClick (val, index, row) {
            this.copyText(document.body, val, false);
        },
        rowDBClick (row) {
            this.$router.push({
                query: { rowData: row },
                path: '/otp/dispatch-Manage/single-list-detail'
            });
        },
        // 导出
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams,
                suppliersCode: this.supplier.supplierCode,
                tenantCode: 'BLANK',
                beginDate2: '2020-11-11 00:00:00', // 后端固定要传参数
                endDate2: '2030-11-11 00:00:00'
            });
            this.isFirstSearch = false;
        },
        searchChange (data) {
            if (data.createTime && data.createTime.length) {
                data.startTime = dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss');
                data.endTime = dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss');
            } else {
                data.startTime = '';
                data.endTime = '';
            }
            delete data.createTime;
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            const beginDate = dayjs(data.startTime).valueOf() || 0;
            const endDate = dayjs(data.endTime).valueOf() || 0;
            const differenceValue = endDate - beginDate;
            const maxDay63 = 1000 * 60 * 60 * 24 * 63;
            if (differenceValue > maxDay63) {
                return this.$message.warning('按时间查询或导出时，查询或导出时间跨度不可超过两个月！');
            }
            this.isFirstSearch = false;
            Object.keys(this.searchParams).map((item) => {
                if (this.searchParams[item] === '') {
                    delete this.searchParams[item];
                }
                return true;
            });
            this.getList();
        },

        // 复制函数
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        pageChange (data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange (data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.searchParams.pageNo = 1;
            this.getList();
        }
    },
    mounted () {
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
        })
    }
}
</script>
<style scoped lang="less">
</style>
